import React, { Component } from "react";

export default class extends Component {
  render = () => (
    <>
      <section className="main_slider_area banner">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p>
                It`s Middlemen-free <span className="line"></span>
              </p>
              <h2>
                Send Eraswap Token to anyone{" "}
                <span>With CouponDApp, Simply</span>
              </h2>
              <h6>
                CouponDApp offers a solution that allows user to send Era Swap
                Tokens via unique file through E-mail
              </h6>
            </div>
            <div className="col-md-6"></div>
          </div>
        </div>
      </section>

      <section
        className="our_company_area our_company_two pad_top p_100 works "
        id="works"
      >
        <div className="container">
          <div className="core_inner">
            <div className="row">
              <div className="col-lg-12 text-center">
                <div className="core_text">
                  <h4>How It Works</h4>
                  <p>
                    You deposit Era Swap Tokens and Share Unique File, then the
                    receiver will get the simple instructions on how to easily
                    create a wallet and redeem ES tokens
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row our_company_inner pad_btm_50">
            <div className="col-lg-4 col-sm-6">
              <div className="company_item">
                <div className="company_text">
                  <img src="img/wallet.png" alt="wallet" height="120" />
                  <h4>Connect Wallet</h4>
                  <p>
                    Connect Your Wallet & Deposit ES tokens to create easily
                    shareable gift coupons.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="company_item">
                <div className="company_text">
                  <img
                    src="img/share.png"
                    alt="share"
                    className=""
                    height="120"
                  />
                  <h4>Share File</h4>
                  <p>
                    Then share generated unique file to the receiver, who will
                    be claiming ES Tokens.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="company_item">
                <div className="company_text">
                  <img src="img/Claim.png" alt="claim" height="120" />
                  <h4>Claim Tokens</h4>
                  <p>
                    Receiver claims Era Swap Tokens using simple instruction on
                    Coupon Dapp.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="effective_area overflow-hidden" id="aboutus">
        <div className="left_text">
          <div className="effect_text_inner">
            <div className="effect_text">
              <h3>About Us</h3>
              <p>
                Coupon Dapp is an initiative of Team Era Swap – So, the
                community can simply share Era Swap in a few simple steps,
                quickly and efficiently. Coupon Dapp is powered on a
                decentralized network of Era Swap; hence there are no central
                authority or any unnecessary middlemen and international
                transaction charges, charged to the users.{" "}
              </p>
              <p>
                Coupon Dapp is one of a dApp from multiple unique dApps of Era
                Swap Life Ecosystem. Users can transact ES Tokens on their day
                to day life activities on any of Era Swap Life decentralized
                platforms, with the efficiency of inexpensive and middlemen
                transactions of value and services.
              </p>
            </div>
          </div>
        </div>
        <div className="right_img">
          <img src="img/effect-img.jpg" alt="" />
        </div>
      </section>

      <section className="tt_client_area pad_btm" id="platforms">
        <div className="container">
          <div className="center_title">
            <h2>Era Swap Platforms</h2>
            <p>
              Decentralized Platforms & Marketplaces of Era Swap Where You Can
              Utilize ES Tokens
            </p>
          </div>
          <div className="client_slider owl-carousel">
            <div className="item">
              <img className="img-fluid" src="img/client/1.png" alt="" />
            </div>

            <div className="item">
              <img className="img-fluid" src="img/client/2.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/3.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/4.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/5.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/6.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/7.png" alt="" />
            </div>

            <div className="item">
              <img className="img-fluid" src="img/client/8.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/9.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/10.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/11.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/12.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/13.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/14.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/15.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/16.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/17.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/18.png" alt="" />
            </div>
            <div className="item">
              <img className="img-fluid" src="img/client/19.png" alt="" />
            </div>
          </div>
        </div>
      </section>

      <section className="home_blog_area blog_three pad_btm">
        <div className="container">
          <div className="blog_title justify-content-between d-flex">
            <h2>Insight at advotis Blog</h2>
            <a href="/">See all posts</a>
          </div>
          <div className="blog_three_inner">
            <div className="row">
              <div className="col-lg-4">
                <div className="h_blog_item">
                  <div className="blog_img">
                    <img
                      className="img-fluid"
                      src="img/blog/home-blog/blog-1.jpg"
                      alt=""
                    />
                    <a className="cat" href="/">
                      Advanced Analytic
                    </a>
                  </div>
                  <div className="blog_text">
                    <a href="single-blog.html">
                      <p>
                        Improve your operational effectiveness and efficiency,
                        and test the results of your customer-facing digital
                      </p>
                    </a>
                    <a className="date" href="/">
                      October 12, 2018
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="h_blog_item">
                  <div className="blog_img">
                    <img
                      className="img-fluid"
                      src="img/blog/home-blog/blog-2.jpg"
                      alt=""
                    />
                    <a className="cat" href="/">
                      Advanced Analytic
                    </a>
                  </div>
                  <div className="blog_text">
                    <a href="single-blog.html">
                      <p>
                        Organically grow the holistic world view of disruptive
                        innovation via work.
                      </p>
                    </a>
                    <a className="date" href="/">
                      December 5, 2018
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="h_blog_item">
                  <div className="blog_img">
                    <img
                      className="img-fluid"
                      src="img/blog/home-blog/blog-4.jpg"
                      alt=""
                    />
                    <a className="cat" href="/">
                      Advanced Analytic
                    </a>
                  </div>
                  <div className="blog_text">
                    <a href="single-blog.html">
                      <p>
                        Nanotechnology immersion along the information highway
                        will close the loop on focusing solely on the bottom
                        line
                      </p>
                    </a>
                    <a className="date" href="/">
                      November 12, 2018
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="conversion_area" id="gifts">
        <div className="container">
          <div className="conversion_inner">
            <div className="row">
              <div className="col-lg-12">
                <div className="conversion_text text-center">
                  <h2 className="pad_btm_50">
                    Ready to Gift ES Tokens to
                    <br /> your friends & family?
                  </h2>
                  <a href="/" className="main_btn main_btn_rounded">
                    Send
                  </a>
                  <h5 className="pad_btm_50">It`s Middlemen-free</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
